/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_BOX_LIST = gql`
  query Content($filter: BoxFilterInput) {
    getBoxes(filter: $filter) {
      content {
        _id
        groupId
        id
        totalAmount
        amountPaid
        payOrder {
          id
          box {
            costumeID
            _id
          }
        }
        items {
          costumeValue {
            id
            name
            topupPrice
            minDownPayment
          }
          costumeAttribute {
            id
          }
          costumeFeature {
            id
          }
          costumeType {
            id
          }
        }
        presentation {
          id
        }
        section {
          id
          name
          costumeTypes {
            name
          }
        }
      }
    }
  }
`;
